import { cn } from '@/lib/cn';

type ProgressTone = 'normal' | 'warning' | 'danger';

interface ProgressBarProps {
  /** Percent used; above 100 fills the bar (the tone says it is over). */
  value: number;
  tone?: ProgressTone;
  label: string;
  className?: string;
}

// The unfilled track is a lighter step of the same hue as the fill, so the state reads across the whole bar.
const tones: Record<ProgressTone, { track: string; fill: string }> = {
  normal: { track: 'bg-brand-tint', fill: 'bg-brand' },
  warning: { track: 'bg-wait-tint', fill: 'bg-wait' },
  danger: { track: 'bg-bad-tint', fill: 'bg-bad' },
};

export const ProgressBar = ({ value, tone = 'normal', label, className }: ProgressBarProps) => {
  const shown = Math.max(0, Math.min(100, value));
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={shown}
      aria-valuetext={`${value}%`}
      className={cn('h-2.5 w-full overflow-hidden rounded-full', tones[tone].track, className)}
    >
      <div className={cn('h-full rounded-full transition-[width]', tones[tone].fill)} style={{ width: `${shown}%` }} />
    </div>
  );
};
